import './authInterceptor';
import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Productos from './pages/Productos';
import Categorias from './pages/Categorias';
import Pedidos from './pages/Pedidos';
import Resenas from './pages/Resenas';
import Banners from './pages/Banners';
import SegundoCatalogo from './pages/SegundoCatalogo';
import Emojis from './pages/Emojis';
import Clientes from './pages/Clientes';
import VentaCredito from './pages/VentaCredito';
import Facturacion from './pages/Facturacion';
import Creditos from './pages/Creditos';
import VentaContado from './pages/VentaContado';
import Vendedores from './pages/Vendedores';
import Reportes from './pages/Reportes';
import Gastos from './pages/Gastos';
import Auditoria from './pages/Auditoria';
import DescargarApp from './pages/DescargarApp';
import Marketing from './pages/Marketing';
import { inicializarNotificaciones } from './notificaciones';

function PrivateRoute({ children }: { children: any }) {
  useEffect(() => {
    if (localStorage.getItem('token')) {
      inicializarNotificaciones();
    }
  }, []);

  return localStorage.getItem('token') ? children : <Navigate to="/login" />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="productos" element={<Productos />} />
          <Route path="categorias" element={<Categorias />} />
          <Route path="pedidos" element={<Pedidos />} />
          <Route path="marketing" element={<Marketing />} />
          <Route path="clientes" element={<Clientes />} />
          <Route path="facturacion" element={<Facturacion />} />
          <Route path="venta-credito" element={<VentaCredito />} />
          <Route path="creditos" element={<Creditos />} />
          <Route path="venta-contado" element={<VentaContado />} />
          <Route path="vendedores" element={<Vendedores />} />
          <Route path="reportes" element={<Reportes />} />
          <Route path="gastos" element={<Gastos />} />
          <Route path="auditoria" element={<Auditoria />} />
          <Route path="descargar-app" element={<DescargarApp />} />
          <Route path="resenas" element={<Resenas />} />
          <Route path="banners" element={<Banners />} />
          <Route path="segundo-catalogo" element={<SegundoCatalogo />} />
          <Route path="emojis" element={<Emojis />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
